const STAR_COLUMN_WIDTH = 36;
const STAR_COLUMN_WIDTH_WITH_HANDLE = 56; // room for the drag handle used for reordering

// Header cells always stick to the top; columns flagged `sticky` also stick to the left edge.
const getStickyStyle = (column, isHeader) => {
  if (!isHeader && !column.sticky) {
    return {};
  }

  const style = { position: "sticky", backgroundColor: "var(--bs-body-bg, #fff)" };
  if (isHeader) {
    style.top = 0;
    style.whiteSpace = "nowrap";
  }
  if (column.sticky) {
    style.left = column.sticky.left;
    style.zIndex = isHeader ? 3 : 1;
  }
  else {
    style.zIndex = 2;
  }
  if (column.key === "starred") {
    style.width = style.minWidth = style.maxWidth = column.starWidth || STAR_COLUMN_WIDTH;
  }
  return style;
};

export { getStickyStyle, STAR_COLUMN_WIDTH, STAR_COLUMN_WIDTH_WITH_HANDLE };
